<script>
import PagePushCard from '@phoenix/mixins/components/molecules/PagePushCard';
import CTA from '@maison/components/common/CTA';
import { PhxsgBackgroundVideo } from '@sg/src/View/Components/Organisms/BackgroundVideo';
import { PhxsgPagePush } from '@sg/src/View/Components/Molecules/PagePush';

export default {
  components: {
    CTA,
    PhxsgBackgroundVideo,
    PhxsgPagePush,
  },

  mixins: [PagePushCard],

  props: {
    cta: {
      type: Object,
      default: null,
    },
    image: {
      type: Object,
      default: null,
    },
    video: {
      type: Object,
      default: null,
    },
    backgroundImage: {
      type: Object,
      default: null,
    },
    backgroundVideo: {
      type: Object,
      default: null,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    clampedDescription: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <phxsg-page-push
    :title="title"
    :media="image"
    :background="backgroundImage"
    :stacked="stacked"
    :description="description"
    :clamped-description="clampedDescription"
    :class="{ 'phxsg-theme-dark': isDark }"
  >
    <template v-if="!backgroundImage && backgroundVideo" #background>
      <phxsg-background-video v-bind="backgroundVideo" />
    </template>

    <template v-if="!image && video" #media>
      <phxsg-background-video v-bind="video" root-class="phxsg-background-video--relative" />
    </template>

    <template v-if="$slots.description" #description>
      <slot name="description" />
    </template>

    <template #cta>
      <c-t-a class="expand-target phxsg-page-push__cta btn--fade" v-bind="cta" />
    </template>
  </phxsg-page-push>
</template>
